<script>
	import { Button, Card, CardBody, CardText } from "@sveltestrap/sveltestrap";
	//import Dialog from "../../../../../SharedSvelte/Dialog.svelte";

	let {
		id = "",
		usageType = "",
		bankName = "",
		routingNumber = "",
		accountType = "",
		accountNumber = "",
		hasPendingChanges = false,
		oneditcallback,
		ondeletecallback
	} = $props();

	//let prompt;

	const isAchAccount = $derived(
		accountType === "Savings" || accountType === "Checking",
	);

	//const isNonStandardAccount = $derived(
	// 	accountType === "URS" ||
	// 		accountType === "LTD" ||
	// 		accountType === "HRA",
	//);

	const displayUsage = $derived.by(() => {
		switch (usageType) {
			case "Claims":
				return "Used for depositing claim reimbursements.";
			case "Premiums":
				return "Used for making premium payments.";
			default:
				return "Used for making premium payments and depositing claim reimbursements.";
		}
	});

	const displayAccountType = $derived.by(() => {
		switch (accountType) {
			case "URS":
				return "URS (Utah Retirement Systems) Account";
			case "LTD":
				return "LTD (Long Term Disability) Account";
			case "HRA":
				return "HRA (Health Reimbursement Arrangement) Account";
			case "Savings":
				return "Savings Account";
			default:
				return "Checking Account";
		}
	});

	let formattedAccountNumber = $derived(hideAllButLast(accountNumber, 4));

	function hideAllButLast(value, numberToShow) {
		if (!value) return "";
		let formatted = "";
		for (let i = 0; i < value.length; i++) {
			if (i < value.length - numberToShow) formatted += "*";
			else formatted += value[i];
		}
		return formatted;
	}

	function handleDeleteClick(event) {
		event.preventDefault();
		if (ondeletecallback) {
			ondeletecallback({ id });
		}
	}

	function startEditing(event) {
		event.preventDefault();
		if (oneditcallback) {
			oneditcallback({ id });
		}
	}
</script>

<Card>
	<CardBody>
		<CardText>
			<ul class="list-group list-group-flush">
				<li class="list-group-item">
					<div class="row">
						<div class="col">
							<strong>{displayAccountType}</strong>
							<br />
							{displayUsage}
						</div>
					</div>
				</li>
			</ul>

			{#if isAchAccount}
				<ul class="list-group list-group-flush">
					<li class="list-group-item">
						<div class="row">
							<div class="col-md-4 col-sm-4 col-xs-4">Name:</div>
							<div class="col-md-6 col-sm-6 col-xs-12 ms-2">
								<strong>{bankName}</strong>
							</div>
						</div>
					</li>
					<li class="list-group-item mt-1">
						<div class="row">
							<div class="col-md-4 col-sm-4 col-xs-12">
								Routing Number:
							</div>
							<div class="col-md-6 col-sm-6 col-xs-12 ms-2">
								<strong>{routingNumber}</strong>
							</div>
						</div>
					</li>
					<li class="list-group-item mt-1">
						<div class="row">
							<div class="col-md-4 col-sm-4 col-xs-12">
								Account Number:
							</div>
							<div class="col-md-6 col-sm-6 col-xs-12 ms-2">
								<strong>{formattedAccountNumber}</strong>
							</div>
						</div>
					</li>
				</ul>
			{/if}
		</CardText>
		{#if hasPendingChanges}
			<div class="alert alert-warning">
				There are pending changes to this account.	
			</div>
		{:else}
			<Button color="primary" class="btn-lg me-3" onclick={startEditing}>Edit</Button>
			<Button color="danger" class="btn-lg" onclick={handleDeleteClick}>Remove</Button>
		{/if}
	</CardBody>
</Card>

<!-- <Dialog bind:this={prompt} /> -->

